import React, { Component } from 'react'
import { FormattedDate, FormattedMessage, FormattedRelative, FormattedTime } from 'react-intl'
import Icon from "../../common/icon/icon.component.jsx";
import { GlobalHelper } from '../../indexImports.js';
import QuestionConversationChatModal from "../../question-conversation/questionconversationchatmodal.jsx"
import { TYPE_SMS } from '../../state/conversation/ConversationThreadTypes.ts';
import ImageGallery from "../../common/image/gallery.component";

class AnalyticsQuoteQuestions extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            project: this.props.project || null,
            conversationThreads: (this.props.project && this.props.project.attributes.conversationThreads.length > 0 && this.props.selectedThread != -1)
                ? this.props.project.attributes.conversationThreads : [
                    {
                        messages: []
                    }
                ],
            selectedThread: this.props.selectedThread,
            threadType: this.props.threadType || '',
            onClose: this.props.onClose || function () { },
            contactFirstName: this.props.contactFirstName || '',
            invoiceId: this.props.invoiceId || '',
            quoteId: this.props.quoteId || '',
            orderId: this.props.orderId || '',
            modal: '',
        }
        this.openConversationModal = this.openConversationModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            project: nextProps.project || null,
            conversationThreads: (nextProps.project && nextProps.project.attributes.conversationThreads.length > 0)
                ? nextProps.project.attributes.conversationThreads : [
                    {
                        messages: []
                    }
                ],
            selectedThread: nextProps.selectedThread,
            contactFirstName: nextProps.contactFirstName || '',
            invoiceId: nextProps.invoiceId || '',
            quoteId: nextProps.quoteId || '',
            orderId: nextProps.orderId || '',
        })
    }

    openConversationModal(event) {
        event.preventDefault()
        const customerPhoneNumbers = this.state.project.attributes.contact.attributes.phoneNumbers
        const customerNumber = GlobalHelper.getCustomerNumber(customerPhoneNumbers)
        const countryCode = this.state.project.attributes.address.countryCode
        const internationalNumber = GlobalHelper.getInternationalPhoneNumber(customerNumber, countryCode)

        this.setState({
            modal: <QuestionConversationChatModal
                threadType={this.state.threadType}
                publicLink={this.props.publicLink}
                project={this.state.project}
                customerPhoneNumber={internationalNumber}
                selectedThread={this.state.selectedThread}
                onClose={this.closeModal}
                invoiceId={this.state.invoiceId}
                orderId={this.state.orderId}
                quoteId={this.state.quoteId} />
        })
    }

    closeModal() {
        this.setState({
            modal: '',
        }, () => {
            this.state.onClose()
        })
    }

    render() {
        let conversation = (this.state.conversationThreads && this.state.conversationThreads.length > 0 && this.props.selectedThread != -1) ?
            this.state.conversationThreads[this.state.selectedThread] : { messages: [] }
        let lastMessage = conversation && conversation.messages.length > 0 ? conversation.messages[conversation.messages.length - 1] : null

        return conversation && conversation.messages.length > 0 ?
            [<div key={0} className={'w-100 d-flex bg-light p-2 mb-2'}>

                {this.state.modal}

                <div className={'min-width-zero'}>
                    <p className={'m-0 text-secondary'}>
                        <strong className={'mr-1'}>
                            {lastMessage.attributes.sender === "customer" ?
                                <FormattedMessage
                                    id="quote.analytics.email.last_message_sent_by_customer_label"
                                    defaultMessage="Last message sent by {senderName}:"
                                    values={{
                                        senderName: this.state.project.attributes.contact.attributes.name,
                                    }}
                                /> : <FormattedMessage
                                    id="quote.analytics.email.last_message_sent_by_seller_label"
                                    defaultMessage="Your last reply:"
                                />
                            }
                        </strong>
                    </p>

                    <h5 className={'m-0 border-0 pb-0 mb-2 text-break my-2'}>
                        {lastMessage.attributes.content === '' && lastMessage.attributes.images ?
                            <ImageGallery
                                value={[lastMessage.attributes.images[lastMessage.attributes.images.length-1]]}
                            /> : lastMessage.attributes.content
                        }
                    </h5>

                    <p className={'m-0 text-secondary'}>
                        <FormattedMessage
                            id="quote.analytics.question.last_message_sent_time_ago_label"
                            defaultMessage="Sent "
                        /> <FormattedRelative value={new Date(lastMessage.attributes.createdAt)} />
                    </p>
                </div>
                <div className={'ml-auto text-right'}>
                    <p className={'m-0 text-secondary text-right'}>
                        <small>
                            <FormattedDate
                                year='numeric'
                                month='long'
                                day='numeric'
                                value={new Date(lastMessage.attributes.createdAt)}
                            />
                            &nbsp;
                            <FormattedTime value={new Date(lastMessage.attributes.createdAt)} />
                        </small>
                    </p>
                    <a href="#" onClick={this.openConversationModal} class="badge badge-primary px-2 py-1 my-2">
                        {conversation.messages.length} <FormattedMessage
                            id="quote.analytics.question.messages"
                            defaultMessage="message(s)"
                        />
                    </a>
                </div>
            </div>,

            <button key={1} type="button" className="btn btn-primary mb-4" onClick={this.openConversationModal}>
                <Icon value={this.state.threadType == TYPE_SMS ? "mobile" : "comment"} className={"mr-1"} /> 
                {
                    this.state.threadType == TYPE_SMS
                    ? <FormattedMessage
                        id="quote.analytics.question.reply_to_name_sms_new"
                        defaultMessage="SMS {name}"
                        values={{name: this.state.contactFirstName}}
                    />
                    : <FormattedMessage
                        id="quote.analytics.question.reply_to_name_reply_new"
                        defaultMessage="Reply to {name}"
                        values={{name: this.state.contactFirstName}}
                    />
                    
                }
            </button>] :

            [<div key={1} className={'w-100 text-secondary text-center py-2 mb-2 strong'} style={{ border: '5px dashed #dee2e6' }}>
                {this.state.modal}
                <em>
                    <FormattedMessage
                        id="quote.analytics.question.no_question_asked"
                        defaultMessage="No question at the moment"
                    />
                </em>
            </div>,
            <button key={2} type="button" className="btn btn-primary mb-2" onClick={this.openConversationModal}>
                <Icon value={this.state.threadType == TYPE_SMS ? "mobile-alt" : "comment"} className={"mr-1"} /> 
                {
                    this.state.threadType == TYPE_SMS
                    ? <FormattedMessage
                        id="quote.analytics.question.reply_to_name_sms_new"
                        defaultMessage="SMS {name}"
                        values={{name: this.state.contactFirstName}}
                    />
                    : <FormattedMessage
                        id="quote.analytics.question.reply_to_name_reply_new"
                        defaultMessage="Reply to {name}"
                        values={{name: this.state.contactFirstName}}
                    />
                    
                }
            </button>]
    }

}

export default AnalyticsQuoteQuestions





// WEBPACK FOOTER //
// ./src/quote/analytics/quotequestions.component.jsx